import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExitNoteService {

  private URL = environment.api + "api/erp/exit-notes";

  constructor(private http: HttpClient) { }

  getExitNotes() {
    return this.http.get(this.URL);
  }

  getExitNoteById(id) {
    return this.http.get(this.URL + `/${id}`);
  }

  createExitNote(request) {
    return this.http.post(this.URL, request);
  }

  updateExitNote(id, request) {
    return this.http.put(this.URL + `/${id}`, request);
  }

  deleteExitNote(id) {
    return this.http.delete(this.URL + `/${id}`);
  }

  getExitNoteDetails(id) {
    return this.http.get(this.URL + `/details/${id}`);
  }

  getExitNotesAll() {
    return this.http.get(this.URL + '/');
  }

  getExitNotesAllAssociated() {
    return this.http.get(this.URL + '/notes-associated');
  }

  getExitNotesAllNotAssociated() {
    return this.http.get(this.URL + '/notes-no-associated');
  }

  isExisteOtherAssociationExitNoteOrder(entryNoteId: number, orderId: number) {
    return this.http.get(this.URL + `/associated-orders/${entryNoteId}/order/${orderId}`);
  }
}
